import { useDisclosure } from "@msuite/ui/hooks";
import { useTranslation } from "@msuite/ui/localization";
import { Popover } from "@msuite/ui/popover";
import { Tag } from "@msuite/ui/tag";
import {
	getCalculationTypeColor,
	getCalculationTypeTranslationKey,
} from "@msuite/utils/partnerships";
import type { TicketTimelineItem as TicketTimelineItemType } from "@msuite/utils/types";
import Notes, { NoteHintButton } from "@/components/notes";

/** Props Interface */
interface TicketTimelineItemProps {
	item: TicketTimelineItemType;
}

export function TicketTimelineItem({ item }: TicketTimelineItemProps) {
	const { t } = useTranslation();
	const notesDisclosure = useDisclosure();

	/** Render */
	return (
		<div className="card v-stack">
			<div className="h-stack justify-between">
				<p>
					{item.organizationName} {item.crewRanking}
				</p>
				<Tag
					color={getCalculationTypeColor(item.calculationType)}
					variant="plain"
				>
					{t(getCalculationTypeTranslationKey(item.calculationType))}
				</Tag>
			</div>
			<div className="h-stack justify-end">
				<Popover
					trigger="click"
					variant="plain"
					render={() => (
						<div className="w-[700px] max-h-full shrink">
							<Notes
								notesTable="ticketAssignmentNotes"
								identifier={item.id}
								draggable
							/>
						</div>
					)}
				>
					<NoteHintButton
						notesTable="ticketAssignmentNotes"
						identifier={item.id}
						disclosure={notesDisclosure}
					/>
				</Popover>
			</div>
		</div>
	);
}
